
;(function seibertronDirtclawGalleryRestore20260714() {
  var scriptFile = 'dirtclaw-gallery-restore-20260714.js';
  var handle = "motocross-gloves";
  var config = {
    "defaultValue": "White",
    "chartFiles": [
    {
            "file": "dirtclaw-adult-youth-size-chart-user-20260724-v2.png",
            "width": 972,
            "height": 1619,
            "alt": "Seibertron Dirtclaw adult and youth fingerless motocross gloves size chart with hand measurement method"
    }
  ],
    "entries": [
        {
            "id": "33403638022334",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/3_3cdf8ee1-dc9e-4e80-a1dd-4070a711e257.jpg?v=1783672353",
            "alt": "color:White | Seibertron Dirtclaw fingerless motocross gloves white background main image"
        },
        {
            "id": "33374838161598",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-01.jpg?v=1783400652",
            "alt": "color:White | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 01"
        },
        {
            "id": "33374838194366",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-02.jpg?v=1783400651",
            "alt": "color:White | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 02"
        },
        {
            "id": "33374838227134",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-03.jpg?v=1783400652",
            "alt": "color:White | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 03"
        },
        {
            "id": "33374838259902",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-04.jpg?v=1783400651",
            "alt": "color:White | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 04"
        },
        {
            "id": "33374839144638",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-31.jpg?v=1783400651",
            "alt": "color:all | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 31"
        },
        {
            "id": "33440505954494",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-dirtclaw-black-white-bg-main-20260714.jpg?v=1783996717",
            "alt": "color:Black | Seibertron Dirtclaw fingerless motocross gloves white background main image"
        },
        {
            "id": "33374838325438",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-06.jpg?v=1783400651",
            "alt": "color:Black | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 06"
        },
        {
            "id": "33374838358206",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-07.jpg?v=1783400651",
            "alt": "color:Black | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 07"
        },
        {
            "id": "33374838390974",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-08.jpg?v=1783400652",
            "alt": "color:Black | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 08"
        },
        {
            "id": "33374838423742",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-09.jpg?v=1783400652",
            "alt": "color:Black | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 09"
        },
        {
            "id": "33440506740926",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-dirtclaw-red-white-bg-main-20260714.jpg?v=1783996724",
            "alt": "color:Red | Seibertron Dirtclaw fingerless motocross gloves white background main image"
        },
        {
            "id": "33374838489278",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-11.jpg?v=1783400652",
            "alt": "color:Red | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 11"
        },
        {
            "id": "33374838522046",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-12.jpg?v=1783400651",
            "alt": "color:Red | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 12"
        },
        {
            "id": "33374838554814",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-13.jpg?v=1783400651",
            "alt": "color:Red | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 13"
        },
        {
            "id": "33374838587582",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-14.jpg?v=1783400652",
            "alt": "color:Red | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 14"
        },
        {
            "id": "33374838653118",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-16.jpg?v=1783400651",
            "alt": "color:Blue | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 16"
        },
        {
            "id": "33374838685886",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-17.jpg?v=1783400652",
            "alt": "color:Blue | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 17"
        },
        {
            "id": "33374838718654",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-18.jpg?v=1783400651",
            "alt": "color:Blue | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 18"
        },
        {
            "id": "33374838751422",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-19.jpg?v=1783400651",
            "alt": "color:Blue | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 19"
        },
        {
            "id": "33374838784190",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-20.jpg?v=1783400652",
            "alt": "color:Blue | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 20"
        },
        {
            "id": "33374838816958",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-21.jpg?v=1783400652",
            "alt": "color:Orange | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 21"
        },
        {
            "id": "33374838849726",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-22.jpg?v=1783400652",
            "alt": "color:Orange | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 22"
        },
        {
            "id": "33374838882494",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-23.jpg?v=1783400651",
            "alt": "color:Orange | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 23"
        },
        {
            "id": "33374838915262",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-24.jpg?v=1783400652",
            "alt": "color:Orange | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 24"
        },
        {
            "id": "33374838948030",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-25.jpg?v=1783400651",
            "alt": "color:Orange | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 25"
        },
        {
            "id": "33374838980798",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-26.jpg?v=1783400652",
            "alt": "color:Fluorescent Yellow | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 26"
        },
        {
            "id": "33374839013566",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-27.jpg?v=1783400651",
            "alt": "color:Fluorescent Yellow | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 27"
        },
        {
            "id": "33374839046334",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-28.jpg?v=1783400651",
            "alt": "color:Fluorescent Yellow | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 28"
        },
        {
            "id": "33374839079102",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-29.jpg?v=1783400651",
            "alt": "color:Fluorescent Yellow | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 29"
        },
        {
            "id": "33374839111870",
            "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtclaw-fingerless-gallery-30.jpg?v=1783400651",
            "alt": "color:Fluorescent Yellow | Seibertron Dirtclaw fingerless motocross and off-road riding gloves image 30"
        },
        {
            "id": "33450619338942",
            "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-dirtclaw-blue-white-bg-main-20260715.jpg?v=1784101292",
            "alt": "color:Blue | Seibertron Dirtclaw fingerless motocross gloves white background main image"
        },
        {
            "id": "33450620190910",
            "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-dirtclaw-orange-white-bg-main-20260715.jpg?v=1784101304",
            "alt": "color:Orange | Seibertron Dirtclaw fingerless motocross gloves white background main image"
        },
        {
            "id": "33450618224830",
            "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-dirtclaw-fluorescent-yellow-white-bg-main-20260715.jpg?v=1784101285",
            "alt": "color:Fluorescent Yellow | Seibertron Dirtclaw fingerless motocross gloves white background main image"
        }
    ],
    "groups": {
        "White": [
            "33403638022334",
            "33374838161598",
            "33374838194366",
            "33374838227134",
            "33374838259902",
            "33374839144638"
        ],
        "Black": [
            "33440505954494",
            "33374838325438",
            "33374838358206",
            "33374838390974",
            "33374838423742",
            "33374839144638"
        ],
        "Red": [
            "33440506740926",
            "33374838489278",
            "33374838522046",
            "33374838554814",
            "33374838587582",
            "33374839144638"
        ],
        "Blue": [
            "33450619338942",
            "33374838653118",
            "33374838685886",
            "33374838718654",
            "33374838751422",
            "33374838784190",
            "33374839144638"
        ],
        "Orange": [
            "33450620190910",
            "33374838816958",
            "33374838849726",
            "33374838882494",
            "33374838915262",
            "33374838948030",
            "33374839144638"
        ],
        "Fluorescent Yellow": [
            "33450618224830",
            "33374838980798",
            "33374839013566",
            "33374839046334",
            "33374839079102",
            "33374839111870",
            "33374839144638"
        ]
    },
    "incompleteWhiteBackgroundValues": []
};
  function absolute(url) { if (!url) return ''; if (url.indexOf('//') === 0) return window.location.protocol + url; if (url.charAt(0) === '/') return window.location.origin + url; return url; }
  function sized(url, width) { try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; } catch (error) { return absolute(url); } }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; }); }
  function scriptUrl(file) {
    var own = Array.prototype.find.call(document.scripts, function (script) { return script.src && script.src.indexOf(scriptFile) !== -1; });
    if (own) return own.src.replace(scriptFile, file);
    return '/cdn/shop/t/16/assets/' + file;
  }
  function ensureStyle() {
    var style = document.getElementById('dirtclaw-gallery-restore-style-20260714') || document.createElement('style');
    style.id = 'dirtclaw-gallery-restore-style-20260714';
    var scope = '.auto-product[data-product-handle="' + handle + '"]';
    style.textContent = scope + ' [data-auto-visual-option-value] [data-auto-choice-label]{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff;position:relative;cursor:pointer}' +
      scope + ' .auto-product__swatch-image{display:block;width:100%;height:100%;pointer-events:none}' +
      scope + ' .auto-product__swatch-image img{display:block;width:100%;height:100%;object-fit:contain;background:#fff;pointer-events:none}' +
      scope + ' .auto-product__swatch-label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;pointer-events:none}';
    if (!style.parentNode) document.head.appendChild(style);
  }
  function entryMap() {
    if (config.entryById) return config.entryById;
    config.entryById = {};
    config.entries.forEach(function (entry) { config.entryById[entry.id] = entry; });
    return config.entryById;
  }
  function groupFor(value) {
    var entries = entryMap();
    return (config.groups[value] || config.groups[config.defaultValue] || []).map(function (id) { return entries[id]; }).filter(Boolean);
  }
  function selectedValue(root) {
    var checkedInSwatch = root.querySelector('[data-auto-visual-option-value] input:checked');
    if (checkedInSwatch) {
      var holder = checkedInSwatch.closest('[data-auto-visual-option-value]');
      if (holder) return holder.getAttribute('data-auto-visual-option-value') || config.defaultValue;
    }
    return config.defaultValue;
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function setActiveThumb(root, activeId) {
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === activeId);
    });
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
    }
    wrap.appendChild(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      setActiveThumb(root, entry.id);
    };
    visibleIds[entry.id] = true;
  }
  function showGroup(root, value, preferredId) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(value);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[thumb.getAttribute('data-media-id')];
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }
    var active = entryMap()[preferredId] && visibleIds[preferredId] ? entryMap()[preferredId] : group[0];
    setMain(root, active);
    setActiveThumb(root, active.id);
  }
  function hydrateSwatches(root) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = label.getAttribute('data-auto-visual-option-value') || '';
      var entry = groupFor(value)[0];
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      var nextSrc = sized(entry.src, 180);
      var currentImg = shell.querySelector('img');
      var currentSrc = currentImg ? absolute(currentImg.getAttribute('src') || '') : '';
      if (currentSrc === nextSrc || currentSrc.replace(/&amp;/g, '&') === nextSrc) return;
      shell.dataset.display = value;
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(nextSrc) + '" alt="' + escapeHtml(value) + '" width="78" height="78" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
    });
  }
  function replaceChart(root) {
    var images = root.querySelectorAll('img.auto-product__guide-image');
    var chart = config.chartFiles[0];
    if (!chart || !images.length) return;
    var img = images[0];
    img.src = scriptUrl(chart.file);
    img.srcset = '';
    img.width = chart.width;
    img.height = chart.height;
    img.alt = chart.alt;
    Array.prototype.slice.call(images, 1).forEach(function (extra) { extra.remove(); });
  }
  function selectedGroupVisible(root) {
    var group = groupFor(selectedValue(root));
    if (!group.length) return true;
    var visibleIds = Array.prototype.map.call(root.querySelectorAll('[data-auto-thumb]:not([hidden])'), function (thumb) {
      return thumb.getAttribute('data-media-id') || '';
    });
    return group.every(function (entry) { return visibleIds.indexOf(entry.id) !== -1; });
  }
  function stabilize(root) {
    ensureStyle();
    replaceChart(root);
    hydrateSwatches(root);
    if (!selectedGroupVisible(root)) showGroup(root, selectedValue(root));
  }
  function runOne() {
    var root = document.querySelector('.auto-product[data-product-handle="' + handle + '"]');
    if (!root) return;
    stabilize(root);
    showGroup(root, selectedValue(root));
    var flag = 'dirtclawGalleryRestoreBound';
    if (!root.dataset[flag]) {
      root.dataset[flag] = 'true';
      root.addEventListener('click', function (event) {
        var swatch = event.target && event.target.closest ? event.target.closest('[data-auto-visual-option-value]') : null;
        if (!swatch || !root.contains(swatch)) return;
        if (swatch.classList && swatch.classList.contains('is-unavailable')) return;
        var clickedValue = swatch.getAttribute('data-auto-visual-option-value') || config.defaultValue;
        var input = swatch.querySelector('input[type="radio"]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        [0, 80, 350, 900, 1600].forEach(function (delay) {
          window.setTimeout(function () {
            replaceChart(root);
            hydrateSwatches(root);
            showGroup(root, clickedValue);
          }, delay);
        });
      });
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          [0, 350, 900, 1600].forEach(function (delay) {
            window.setTimeout(function () {
              replaceChart(root);
              hydrateSwatches(root);
              showGroup(root, selectedValue(root));
            }, delay);
          });
        }
      });
      var observerFlag = 'dirtclawGalleryRestoreObserver';
      if (!root.dataset[observerFlag]) {
        root.dataset[observerFlag] = 'true';
        var visualWrap = root.querySelector('[data-auto-visual-option-value]');
        visualWrap = visualWrap && visualWrap.closest('fieldset') ? visualWrap.closest('fieldset') : root;
        var pending = false;
        var observer = new MutationObserver(function () {
          if (pending) return;
          pending = true;
          window.setTimeout(function () {
            pending = false;
            stabilize(root);
          }, 40);
        });
        observer.observe(visualWrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked', 'src'] });
      }
    }
  }
  runOne();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runOne, { once: true });
  [80, 250, 600, 1000, 1500, 2200, 3200, 5000, 7500, 10000].forEach(function (delay) { window.setTimeout(runOne, delay); });
  var pulseStarted = Date.now();
  function pulse() {
    var root = document.querySelector('.auto-product[data-product-handle="' + handle + '"]');
    if (root) stabilize(root);
    if (Date.now() - pulseStarted < 18000) window.setTimeout(pulse, 250);
  }
  pulse();
})();
